export default __webpack_public_path__ + "static/media/mini-auesome-logo.c1b6ad68.png";